module.exports = __webpack_public_path__ + "assets/web-227b9cc22e0ba8b2bc8a3b0e080db4a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./pages/Home/assets/web.jpg
// module id = 638
// module chunks = 0 1